import React, { useState, useMemo } from 'react';
import { Grid } from '@mui/material';
import SalesActionStatChartBox from './SalesActionStatChartBox';
import SalesActionStatTable from './SalesActionStatTable';
import SalesActionStatWorkingBaseCard from './SalesActionStatWorkingBaseCard';

function SalesActionStatGrid({ 
  statEvents = [],
  actionEvents = [],
  holidayList = [],
  targetWorkMinutes, 
  baseWorkMinutes,
  startYear,
  startMonth,
  endYear,
  endMonth,
  userCount = 1, 
  onRowClick
}) {
  const [selectedAction, setSelectedAction] = useState('전체');

  const filteredDetailedEvents = useMemo(() => {
    if (selectedAction === '전체') return actionEvents;
    if (selectedAction === '미가동 시간') return [];
    return actionEvents.filter(row => row.actionName === selectedAction);
  }, [actionEvents, selectedAction]);

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12} md={9.0}>
        <SalesActionStatChartBox 
          statEvents={statEvents}
          selectedAction={selectedAction}
          setSelectedAction={setSelectedAction}
          baseWorkMinutes={baseWorkMinutes}
          userCount={userCount} 
        />
      </Grid>

      <Grid item xs={12} md={3.0}>
        <SalesActionStatWorkingBaseCard
          statEvents={statEvents}
          holidayList={holidayList}
          targetWorkMinutes={targetWorkMinutes}
          baseWorkMinutes={baseWorkMinutes}
          startYear={startYear}
          startMonth={startMonth}
          endYear={endYear}
          endMonth={endMonth}
          userCount={userCount}
        />
      </Grid>

      <Grid item xs={12}>
        <SalesActionStatTable filteredEvents={filteredDetailedEvents} onRowClick={onRowClick} />
      </Grid>
    </Grid>
  );
}

export default SalesActionStatGrid;
